<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">REGISTRAR INCIDENCIAS</h5>
        <div class="col-12 col-md-12 row mt-4">
          <div class="col-12 col-md-3 ">
            <label><br> </label>

          </div>
        </div>

        <div class="row">
          <div
              class="table-responsive mt-3"
              style="overflow-y:scroll; height:700px;"
          >
            <table class="table table-striped table-bordered">
              <tr class="text-center">

                <td>
                  <label class="mr-sm-2" for="inline-form-custom-select-pref">Empresa</label>
                  <select
                      class="custom-select"

                      v-model="seleccionado"
                      @change="getConfigEmpresa()"

                  >
                    <option value="">SELECCIONAR EMPRESA</option>
                    <option
                        v-for="(t, i) in vempresas"
                        :value="t.id_empresa"
                        :key="t.nombre_empresa + i"
                    >{{ t.nombre_empresa}}</option
                    >
                  </select>

                </td>

                <td colspan="2">
                  <label class="mr-sm-2" for="inline-form-custom-select-pref">Vuelo</label>
                  <select
                      class="custom-select"
                      v-model="vueloselec"
                  >
                    <option value="">SELECCIONAR VUELO</option>
                    <option
                        v-for="(t, i) in confempresa"
                        :value="t.id_config_empresa"
                        :key="i"
                    >{{ t.nro_vuelo}}</option
                    >
                  </select>
                </td>
              </tr>
              <tr class="text-center">
                <th><small class="font-weight-bold">CÓDIGO</small></th>
                <th><small class="font-weight-bold">OBSERVACION</small></th>
                <th> <small class="font-weight-bold">DETALLE</small></th>
              </tr>
              <tr v-for="(item, index) in dataenv.incidencias" :key="index" class="text-center">
                <td>
                  <small>{{item.Nombre}}</small>
                </td>
                <td>
                  <select
                      class="custom-select"
                      v-model="item.iderror"
                      @change="seleccionarError(item)"
                  >
                    <option v-for="(err, ind) in erroresUno"
                            :value="err.iderror"
                            :key="err.nombre + index +ind">
                      {{ err.nombre}}
                    </option>
                  </select>
                </td>
                <td>
                  <b-form-textarea
                      id="item.id"
                      v-model="item.observacion_equipo"
                      :placeholder="(item.iderror === 1000)?'Ingrese su detalle':'Sin detalle'"
                      rows="2"
                      :disabled="(item.iderror === 1000)?false:true"
                  ></b-form-textarea>
                </td>
                <td>
                  <!-- <input type="checkbox" aria-label="Checkbox for following text input" v-model="item.estado"> -->
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <b-form-textarea
                      id="item.id"
                      v-model="dataenv.observacion"
                      placeholder="Ingrese su observación"
                      rows="2"
                  ></b-form-textarea>
                </td>
              </tr>
              <tr>
                <td colspan="1">

                </td>
                <td>
                  <button
                      class="btn btn-warning mx-2"
                      type="button"
                      @click="limpiarObservacion()"
                  >
                    <i class="fa fa-undo"> Limpiar</i>
                  </button>
                  <button
                      class="btn btn-success"
                      type="button"
                      @click="guardarObservacion()"
                  >
                    <i class="fa fa-send-o"> Enviar</i>
                  </button>
                </td>
              </tr>
            </table>

          </div>
        </div>
      </div>
    </div>
    <Loading v-show="cargando" />
    <b-modal
        class="modal fade"
        title="Observaciones"
        size="xl"
        hide-footer
        ref="modalObservacion"
        :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-bordered table-condensed">

              <thead>
              <tr class="text-center">
                <th><small class="font-weight-bold">NOMBRE FRONTERA</small></th>
                <th><small class="font-weight-bold">EQUIPO</small></th>
                <th><small class="font-weight-bold">ERROR</small></th>
                <th><small class="font-weight-bold">EN CASO DE OTRO</small></th>
                <th><small class="font-weight-bold">ESTADO</small></th>
                <th><small class="font-weight-bold">COMENTARIO SOPORTE</small></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in incidenciasdet" :key="index">
                <td>
                  <small>{{ item.cod_frontera }}</small>
                </td>
                <td class="text-center">
                  <small> {{ item.equipo }}</small>
                </td>
                <td class="text-center">
                  {{item.nombre}}
                </td>
                <td class="text-center">
                  {{item.observacion_equipo}}
                </td>
                <td class="text-center">
                  {{(item.estado_registro == 1 )?'ENVIADO':'SOLUCIONADO'}}
                </td>
                <td class="text-center">
                  {{item.solucion_soporte}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
//import { required } from "vuelidate/lib/validators";
export default {
  name: "listaRobot",
  components: {
    Loading,
  },
  data() {
    return {
      seleccionado:'',
      seleccionadoerr1:'',
      seleccionadoerr2:'',
      seleccionadoerr3:'',
      seleccionadoerr4:'',
      seleccionadoerr5:'',
      vueloselec:'',
      fields:[],
      vempresas:[],
      confempresa:[],
      dataenv:{},
      observacionclean:[],
      perPage: 3,
      currentPage: 1,
      id_config_flujo:null,
      parametro: '',
      incidenciasgenNew:[],
      incidenciasgen:[],
      incidenciasdet:[],
      observacion : {
        descripcion:'',
        vuelo:'',
        fecha:'28/01/16'
      },
      observaciones:[],
      cargando: false,
      erroresUno:[],
      erroresDos:[],
      erroresTres:[],
      erroresCuatro:[],
      erroresCinco:[],
      fecha_ini:null,
      fecha_fin: null
    };
  },
  methods: {
    async guardarObservacion(){
     // console.log(this.dataenv)
      this.dataenv.id_config_flujo = this.vueloselec;
      this.dataenv.incidencias = JSON.stringify(this.dataenv.incidencias);
      await this.axios.post(`/setIncidencias`, this.dataenv);
      this.obtenerRobots();
      this.obtenerIncidenciasGen()
      this.$swal({
        title: "<strong>REGISTRO EXITOSO</strong>",
        type: "success",
        html: `El dato fue registrada`,
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonAriaLabel: "Entendido!",
      })
    },
    async limpiarObservacion(){
      this.dataenv = this.observacionclean;
    },
    async getNombreEmpresas() {
      try {
        let resultados = await this.axios.get(`/get_Empresa_Vuelo`);
        //console.log(resultados)
        this.vempresas = resultados.data.contenido;
        //console.log(this.vempresas);
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getConfigEmpresa() {
      this.cargando = true;
      try {
        this.cargando = false;
        let resultados = await this.axios.get(`/getConfigempresa/${this.seleccionado}`);
        this.confempresa = resultados.data.contenido;
        // console.log(this.confempresa);
        this.cargando = false;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async obtenerIncidenciasGen(){
      //let id_config_flujo=null;
      try {
        ///${id_config_flujo}/${fecha_ini}/${fecha_fin}
        let resultados = await this.axios.get(`/incidencias-gen/${this.id_config_flujo}/${this.fecha_ini}/${this.fecha_fin}`);
        this.incidenciasgenNew= resultados.data.contenido;
        this.fields = ['FRONTERA', 'FECHA',  'OBSERVACION','VER DETALLE'];
        this.incidenciasgen = this.incidenciasgenNew // this.incidenciasgen.map((e) => {return {... e, fecha_reg: new moment(e.fecha_reg).format("YYYY-MM-DD") }})
        // this.incidenciasgen = this.incidenciasgen.map((e)=>{return {fontera:e.cod_frontera, fecha: moment(e.fecha_reg).format("DD-MM-YYYY HH:MM:SS") }})
       // console.log(this.incidenciasgen);
      } catch (error){
        console.log("catch: ", error);
      }
    },

    async obtenerIncidenciasDetalle(id){
      this.$refs["modalObservacion"].show();
      try {
        let resultados = await this.axios.get(`/incidencias-det/${id}`);
        this.incidenciasdet= resultados.data.contenido;
        //console.log(this.incidenciasdet);
      } catch (error){
        console.log("catch: ", error);
      }
    },
    async obtenerErrores(){
      let resultados = await this.axios.get(`/errores`);
      this.erroresUno= resultados.data.contenido;
      this.obtenerRobots();
    },
    onChangeCentro(){

    },
    onChange(){
      this.id_config_flujo=this.vueloselec;
      this.obtenerIncidenciasGen()
    },
    async fechaInicial(value){
      this.fecha_ini = value

      this.obtenerIncidenciasGen()
    },
    async fechaFinal(value){
      this.fecha_fin = value
      this.obtenerIncidenciasGen()
    },

    hideModalObservado() {
      this.$refs["modalObservacion"].hide();
    },
    seleccionarError(item){
      item.observacion_equipo = "";
    },
    async obtenerRobots(){
      let resultados = await this.axios.get(`/robots`);
      this.rbt_robotList = resultados.data.contenido;
      //console.log(this.rbt_robotList);
      this.dataenv = {
        id_config_flujo:"",
        incidencias:this.rbt_robotList.map((e)=> {return {Nombre:e.nombre,observacion_equipo:"", iderror:1}}),
        observacion:"",
      }
    //  console.log(this.dataenv)
    }
  },
  created() {
    this.obtenerErrores(),
        this.getNombreEmpresas(),
        this.obtenerIncidenciasGen()


  },

};
</script>
